import { useTranslation } from "react-i18next";
import styles from "../../Components/Bookings/Bookings.module.css";

export default function CheckOutItemPackage({ card }) {
  const { t, i18n } = useTranslation();

  console.log("card", card);

  if (!card) {
    return <div>{t("No items in the card.")}</div>;
  }

  return (
    <div className={`mx-auto ${styles.box} w-75 my-3 p-2`}>
      <div className="my-3">
        <div className={`${styles.titleBill} mt-1 ${styles.txt_start}`}>
          {i18n.language === "ar" ? card?.itm_nam?.trim() : card?.itm_enm?.trim()}
        </div>
      
        <div className="m-2 d-flex justify-content-end">
          <div className={styles.totalPrice}>
            {card?.prcandtax.toFixed(2)} {t("rs")}
          </div>
        </div>
      </div>
    </div>
  );
}
